import { render, staticRenderFns } from "./leftmenu-toggle.vue?vue&type=template&id=062d704a"
var script = {}
import style0 from "./leftmenu-toggle.vue?vue&type=style&index=0&id=062d704a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports